import React from "react";
import Panel from "../Common/Components/Panel.jsx";
import { FormattedMessage } from "react-intl";

const Update = ({ onUpdate, time, status }) => (
  <FormattedMessage id="app.update">
    {message => (
      <Panel name={message}>
        <div className="last-updated">
          <div className="last-updated__time">
            <strong>
              <FormattedMessage id="app.lastUpdate" />
              {` ${time}`}
            </strong>
          </div>
          <div className="last-updated__refresh">
            {status === "no-new" ? <FormattedMessage id="app.no-new" /> : null}
          </div>
          <button
            disabled={status === "updating"}
            onClick={onUpdate}
            className="btn-orange"
          >
            <FormattedMessage
              id={status === "updating" ? "app.updating" : "app.refresh"}
            />
          </button>
        </div>
      </Panel>
    )}
  </FormattedMessage>
);

export default Update;
